// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"01250a61","633":"80d7cb03"}[chunkId] + ".chunk.js";
};